import React, { createContext, useContext } from 'react';
import { ApolloClient, InMemoryCache } from 'apollo-boost';
import client, { registryShoppingClient, publicClient } from './clients';

const ApolloClientsContext = createContext<{
  client: ApolloClient<InMemoryCache>;
  registryShoppingClient: ApolloClient<InMemoryCache>;
  publicClient: ApolloClient<InMemoryCache>;
} | null>(null);

export const ApolloClientsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ApolloClientsContext.Provider value={{ client, registryShoppingClient, publicClient }}>
      {children}
    </ApolloClientsContext.Provider>
  );
};

export const useApolloClients = () => {
  const context = useContext(ApolloClientsContext);
  if (!context) {
    throw new Error('useApolloClients must be used within ApolloClientsProvider');
  }
  return context;
};

// Hooks for specific clients
export const useClient = () => useApolloClients().client;
export const useRegistryShoppingClient = () => useApolloClients().registryShoppingClient;
export const usePublicClient = () => useApolloClients().publicClient;
